module.exports = __webpack_public_path__ + "img/blanket_3.8bf5e6f7.png";